<details (toggle)="onToggle()" #details>
  <summary #summary role="button" [attr.aria-expanded]="isOpen()">
    <div class="summary-text">
      <span [style.font-weight]="headerFontWeight()"
        >{{ header() }}
        @if (required()) {
          <span aria-hidden="true">&nbsp;*</span>
        }
      </span>
      @if (!isOpen()) {
        <ng-content select=".preview"></ng-content>
      }
    </div>
    <span class="material-symbols-outlined expansion-icon" aria-hidden="true">{{
      isOpen() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    }}</span>
  </summary>
  <div>
    <ng-content></ng-content>
  </div>
</details>
